<template>
  <AsyncSelect v-bind="computedProps" v-on="$listeners">
    <template #item:description="{ item }">
      <v-chip x-small>
        {{ item.orgName }}
      </v-chip>
      <v-chip v-if="!item.isEnabled" x-small color="error" class="ml-1">
        Неактивен
      </v-chip>
    </template>
  </AsyncSelect>
</template>

<script>
import asyncSelectMixin from '@/components/controls/asyncSelectMixin';
import structApi from '@/api/services/structures';

export default {
  extends: asyncSelectMixin,

  props: {
    value: { type: [Array], default: () => [] },
    orgGroupsIds: { type: Array, default: () => [] },
    orgIds: { type: Array, default: () => [] },
    groupIds: { type: Array, default: () => [] },
    multiple: { type: Boolean, default: true },
  },

  computed: {
    query() {
      return {
        orgGroupsIds: this.orgGroupsIds?.join() || undefined,
        orgIds: this.orgIds?.join() || undefined,
        groupIds: this.groupIds?.join() || undefined,
      };
    },
    label() {
      return 'Работник';
    },
  },

  methods: {
    fetcher(params) {
      return structApi.getEmployeePreviews({ ...params, isTest: false });
    },
    fetcherBy(params) {
      return structApi.getEmployeePreviewsBy(params);
    },
  },
};
</script>
